(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-banner"] && !Shopify.designMode) return;
  try {
    
  // C-Banner Section
  // Currently no JS interactions required
  // Placeholder for future enhancements (e.g., parallax, animations)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.c-collection-tabs__tab');
      this.panels = this.querySelectorAll('.c-collection-tabs__panel');
      this.swipers = new Map();
      this.mobileBreakpoint = 768;
      this.init();
    }

    init() {
      this.bindTabEvents();
      this.initSwipers();
      this.handleResize();
    }

    bindTabEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });
    }

    switchTab(selectedTab) {
      const tabIndex = selectedTab.dataset.tabIndex;

      // Update tabs
      this.tabs.forEach((tab) => {
        const isSelected = tab.dataset.tabIndex === tabIndex;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', isSelected);
      });

      // Update panels
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panelIndex === tabIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;

        // Update swiper when panel becomes active
        if (isActive && this.isMobile()) {
          const swiper = this.swipers.get(tabIndex);
          if (swiper) {
            swiper.update();
          }
        }
      });
    }

    isMobile() {
      return window.innerWidth < this.mobileBreakpoint;
    }

    initSwipers() {
      // Wait for Swiper to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwipers(), 100);
        return;
      }

      const swiperContainers = this.querySelectorAll('.swiper[data-swiper-panel]');

      swiperContainers.forEach((container) => {
        const panelIndex = container.dataset.swiperPanel;
        const prevBtn = this.querySelector(`[data-prev-panel="${panelIndex}"]`);
        const nextBtn = this.querySelector(`[data-next-panel="${panelIndex}"]`);
        const pagination = this.querySelector(`[data-pagination-panel="${panelIndex}"]`);

        if (this.isMobile()) {
          this.createSwiper(container, panelIndex, prevBtn, nextBtn, pagination);
        }
      });
    }

    createSwiper(container, panelIndex, prevBtn, nextBtn, pagination) {
      if (this.swipers.has(panelIndex)) return;

      const swiper = new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          768: {
            enabled: false,
          },
        },
      });

      this.swipers.set(panelIndex, swiper);
    }

    destroySwipers() {
      this.swipers.forEach((swiper, key) => {
        if (swiper && swiper.destroy) {
          swiper.destroy(true, true);
        }
      });
      this.swipers.clear();
    }

    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (this.isMobile() && this.swipers.size === 0) {
            this.initSwipers();
          } else if (!this.isMobile() && this.swipers.size > 0) {
            this.destroySwipers();
          }
        }, 150);
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-community"] && !Shopify.designMode) return;
  try {
    
  // C-Community Section JavaScript
  // Add any interactive functionality here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero"] && !Shopify.designMode) return;
  try {
    
  // C-Hero Section JavaScript
  // Pause badge rotation when user prefers reduced motion
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const badges = document.querySelectorAll('.c-hero__badge');
      badges.forEach((badge) => {
        badge.style.animation = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-knowledge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MOBILE_BREAKPOINT = 768;
    const swipers = new Map();

    function initKnowledgeSwipers() {
      const sections = document.querySelectorAll('.c-knowledge-swiper');

      sections.forEach((section) => {
        const swiperElement = section.querySelector('[data-knowledge-swiper]');
        const pagination = section.querySelector('.c-knowledge__pagination');

        if (!swiperElement) return;

        const sectionId = section.id || section.closest('[id]')?.id;

        if (window.innerWidth < MOBILE_BREAKPOINT && typeof Swiper !== 'undefined') {
          if (!swipers.has(sectionId)) {
            const swiper = new Swiper(swiperElement, {
              slidesPerView: 'auto',
              spaceBetween: 39,
              grabCursor: true,
              watchOverflow: true,
              pagination: {
                el: pagination,
                clickable: true,
              },
            });
            swipers.set(sectionId, swiper);
          }
        } else if (window.innerWidth >= MOBILE_BREAKPOINT) {
          if (swipers.has(sectionId)) {
            swipers.get(sectionId).destroy(true, true);
            swipers.delete(sectionId);
          }
        }
      });
    }

    function handleResize() {
      initKnowledgeSwipers();
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKnowledgeSwipers);
    } else {
      initKnowledgeSwipers();
    }

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 150);
    });

    // Handle Shopify section events
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('c-knowledge-swiper')) {
        initKnowledgeSwipers();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-pdp-blades"] && !Shopify.designMode) return;
  try {
    
  /* ========================================
     C PDP BLADES - Interactive Features
     ======================================== */

  /* --- Thumbnail Gallery Navigation --- */
  document.addEventListener('DOMContentLoaded', function () {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;

    const thumbnails = gallery.querySelectorAll('[data-pdp-thumbnail]');
    const slides = gallery.querySelectorAll('[data-pdp-slide]');

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const mediaId = this.dataset.mediaId;

        // Update active thumbnail
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-current', 'true');

        // Update active slide
        slides.forEach(function (s) {
          s.classList.remove('is-active');
          if (s.dataset.mediaId === mediaId) {
            s.classList.add('is-active');
          }
        });
      });
    });

    // Thumbnails scroll navigation
    const navBtn = gallery.querySelector('[data-pdp-nav]');
    const track = gallery.querySelector('[data-pdp-thumbnails-track]');
    if (navBtn && track) {
      navBtn.addEventListener('click', function () {
        track.scrollBy({
          top: 110,
          left: 88,
          behavior: 'smooth',
        });
      });
    }
  });

  /* --- Video Embed (Lazy Load) --- */
  document.addEventListener('DOMContentLoaded', function () {
    const videoContainers = document.querySelectorAll('[data-pdp-video]');

    videoContainers.forEach(function (container) {
      const playBtn = container.querySelector('[data-pdp-video-play]');
      const poster = container.querySelector('[data-pdp-video-poster]');
      const iframeWrapper = container.querySelector('[data-pdp-video-iframe]');

      if (!playBtn || !iframeWrapper) return;

      playBtn.addEventListener('click', function () {
        const videoId = container.dataset.videoId;
        const videoType = container.dataset.videoType;
        let iframeSrc = '';

        if (videoType === 'youtube') {
          iframeSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        } else if (videoType === 'vimeo') {
          iframeSrc = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        }

        if (iframeSrc) {
          const iframe = document.createElement('iframe');
          iframe.src = iframeSrc;
          iframe.setAttribute('allow', 'autoplay; encrypted-media');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', 'Product video');
          iframeWrapper.appendChild(iframe);
          iframeWrapper.removeAttribute('hidden');
          poster.style.display = 'none';
        }
      });
    });
  });

  /* --- Quantity Selector --- */
  document.addEventListener('DOMContentLoaded', function () {
    const minusBtn = document.querySelector('[data-pdp-qty-minus]');
    const plusBtn = document.querySelector('[data-pdp-qty-plus]');
    const qtyInput = document.querySelector('[data-pdp-qty-input]');

    if (!minusBtn || !plusBtn || !qtyInput) return;

    var min = parseInt(qtyInput.min) || 1;
    var max = parseInt(qtyInput.max) || 99;
    var step = parseInt(qtyInput.step) || 1;

    minusBtn.addEventListener('click', function () {
      var current = parseInt(qtyInput.value) || min;
      if (current - step >= min) {
        qtyInput.value = current - step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    plusBtn.addEventListener('click', function () {
      var current = parseInt(qtyInput.value) || min;
      if (current + step <= max) {
        qtyInput.value = current + step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-pdp-revealme"] && !Shopify.designMode) return;
  try {
    
  /* ========================================
     C PDP BLADES - Interactive Features
     ======================================== */

  /* --- Thumbnail Gallery Navigation --- */
  document.addEventListener('DOMContentLoaded', function () {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;

    const thumbnails = gallery.querySelectorAll('[data-pdp-thumbnail]');
    const slides = gallery.querySelectorAll('[data-pdp-slide]');

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const mediaId = this.dataset.mediaId;

        // Update active thumbnail
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-current', 'true');

        // Update active slide
        slides.forEach(function (s) {
          s.classList.remove('is-active');
          if (s.dataset.mediaId === mediaId) {
            s.classList.add('is-active');
          }
        });
      });
    });

    // Thumbnails scroll navigation
    const navBtn = gallery.querySelector('[data-pdp-nav]');
    const track = gallery.querySelector('[data-pdp-thumbnails-track]');
    if (navBtn && track) {
      navBtn.addEventListener('click', function () {
        track.scrollBy({
          top: 110,
          left: 88,
          behavior: 'smooth',
        });
      });
    }
  });

  /* --- Video Embed (Lazy Load) --- */
  document.addEventListener('DOMContentLoaded', function () {
    const videoContainers = document.querySelectorAll('[data-pdp-video]');

    videoContainers.forEach(function (container) {
      const playBtn = container.querySelector('[data-pdp-video-play]');
      const poster = container.querySelector('[data-pdp-video-poster]');
      const iframeWrapper = container.querySelector('[data-pdp-video-iframe]');

      if (!playBtn || !iframeWrapper) return;

      playBtn.addEventListener('click', function () {
        const videoId = container.dataset.videoId;
        const videoType = container.dataset.videoType;
        let iframeSrc = '';

        if (videoType === 'youtube') {
          iframeSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        } else if (videoType === 'vimeo') {
          iframeSrc = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        }

        if (iframeSrc) {
          const iframe = document.createElement('iframe');
          iframe.src = iframeSrc;
          iframe.setAttribute('allow', 'autoplay; encrypted-media');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', 'Product video');
          iframeWrapper.appendChild(iframe);
          iframeWrapper.removeAttribute('hidden');
          poster.style.display = 'none';
        }
      });
    });
  });

  /* --- Quantity Selector --- */
  document.addEventListener('DOMContentLoaded', function () {
    const minusBtn = document.querySelector('[data-pdp-qty-minus]');
    const plusBtn = document.querySelector('[data-pdp-qty-plus]');
    const qtyInput = document.querySelector('[data-pdp-qty-input]');

    if (!minusBtn || !plusBtn || !qtyInput) return;

    var min = parseInt(qtyInput.min) || 1;
    var max = parseInt(qtyInput.max) || 99;
    var step = parseInt(qtyInput.step) || 1;

    minusBtn.addEventListener('click', function () {
      var current = parseInt(qtyInput.value) || min;
      if (current - step >= min) {
        qtyInput.value = current - step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    plusBtn.addEventListener('click', function () {
      var current = parseInt(qtyInput.value) || min;
      if (current + step <= max) {
        qtyInput.value = current + step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-pillars"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sl-id="sl-section-pillars-v1"]').forEach(function (section) {
      var cards = section.querySelectorAll('[data-pillars-card]');
      if (!cards.length) return;

      function expandCard(target) {
        cards.forEach(function (card) {
          if (card === target) {
            card.classList.add('is-expanded');
            card.setAttribute('aria-expanded', 'true');
          } else {
            card.classList.remove('is-expanded');
            card.setAttribute('aria-expanded', 'false');
          }
        });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.classList.contains('is-expanded')) return;
          expandCard(card);
        });

        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            if (card.classList.contains('is-expanded')) return;
            e.preventDefault();
            expandCard(card);
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tabs-items"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-sl-id="sl-section-tabs-items-v1"]');
    if (!section) return;

    const tabs = section.querySelectorAll('.c-tabs-items__tab');
    const panels = section.querySelectorAll('.c-tabs-items__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const index = this.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('hidden', '');
        });

        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        const sectionId = section.getAttribute('data-section-id');
        const targetPanel = document.getElementById('panel-' + sectionId + '-' + index);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
          targetPanel.removeAttribute('hidden');
        }
      });

      tab.addEventListener('keydown', function (e) {
        const tabsArray = Array.from(tabs);
        const currentIndex = tabsArray.indexOf(this);
        let newIndex;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          newIndex = (currentIndex + 1) % tabsArray.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          newIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
        } else if (e.key === 'Home') {
          e.preventDefault();
          newIndex = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          newIndex = tabsArray.length - 1;
        }

        if (newIndex !== undefined) {
          tabsArray[newIndex].click();
          tabsArray[newIndex].focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-video-bg"] && !Shopify.designMode) return;
  try {
    
  class CVideoBg extends HTMLElement {
    constructor() {
      super();
      this.playBtn = this.querySelector('[data-video-play]');
      this.modal = this.querySelector('[data-video-modal]');
      this.closeBtn = this.querySelector('[data-video-close]');
      this.iframe = this.querySelector('[data-video-iframe]');
      this.video = this.querySelector('.c-video-bg__video');
      this.videoUrl = this.playBtn?.dataset.videoUrl;

      this.bindEvents();
      this.handleReducedMotion();
    }

    bindEvents() {
      if (this.playBtn) {
        this.playBtn.addEventListener('click', this.handlePlayClick.bind(this));
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.closeModal.bind(this));
      }

      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.closeModal();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
            this.closeModal();
          }
        });
      }
    }

    handlePlayClick() {
      if (this.videoUrl && this.modal && this.iframe) {
        this.openModal();
      } else if (this.video) {
        // If no external URL, toggle the background video playback
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }
    }

    openModal() {
      const embedUrl = this.getEmbedUrl(this.videoUrl);
      if (embedUrl) {
        this.iframe.src = embedUrl;
        this.modal.classList.add('is-active');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        /* Elevate stacking context so modal appears above header/other sections */
        this.style.zIndex = '10000';
        this.style.overflow = 'visible';
        this.closeBtn.focus();
      }
    }

    closeModal() {
      this.modal.classList.remove('is-active');
      this.modal.setAttribute('aria-hidden', 'true');
      this.iframe.src = '';
      document.body.style.overflow = '';
      /* Restore original stacking context */
      this.style.zIndex = '';
      this.style.overflow = '';
      this.playBtn.focus();
    }

    getEmbedUrl(url) {
      if (!url) return null;

      // YouTube
      const youtubeMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (youtubeMatch) {
        return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1&rel=0`;
      }

      // Vimeo
      const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vimeoMatch) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
      }

      return null;
    }

    handleReducedMotion() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('autoplay');
        }
      }
    }
  }

  customElements.define('c-video-bg', CVideoBg);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
